import {
  DIVISIONS_WITH_DIVISIONAL_RANKING,
  DIVISIONS_WITH_REGIONAL_RANKING,
  DIVISION_I,
} from '@/core/constants';

export function getRankingPositionDisplay(ranking?: {
  rank?: number;
  division?: string;
  regionalRank?: number;
}): {
  label: string;
  value: number;
} {
  if (ranking) {
    if (ranking.rank) {
      return {
        label: `National Rank`,
        value: ranking.rank ?? 0,
      };
    } else if (ranking.division !== DIVISION_I) {
      return {
        label: 'Regional Rank',
        value: ranking.regionalRank ?? 0,
      };
    }
  }
  return {
    label: `National Rank`,
    value: 0,
  };
}

export function getRankingsInfo(division: string, isRegionalDivision?: boolean) {
  return DIVISIONS_WITH_REGIONAL_RANKING.includes(division) && isRegionalDivision
    ? 'Rankings are Regional'
    : 'Rankings are National';
}

export function getRankingsSortField(division?: string, isRegionalDivision?: boolean) {
  if (division) {
    if (DIVISIONS_WITH_REGIONAL_RANKING.includes(division) && isRegionalDivision) {
      return 'regionalRank';
    } else if (DIVISIONS_WITH_DIVISIONAL_RANKING.includes(division)) {
      return 'rank';
    }
  }
  return 'rank';
}
